/**
 * CopaAlbumContext — fonte ÚNICA do estado do Álbum da Copa 2026.
 *
 * Antes, `CopaModal` e `CopaAlbumWidget` chamavam `useCopaAlbum` cada um por conta
 * própria — duas instâncias = ~10 chamadas de rede por load do Dashboard, e
 * contadores podendo divergir (o widget rodava sem `cycleId`).
 *
 * Agora o Provider roda o hook UMA vez (com o `cycleId` correto) e ambos consomem
 * via contexto: metade das chamadas e estado consistente entre modal e widget.
 */

import React, { createContext, useContext } from 'react';
import { useCopaAlbum, UseCopaAlbumResult } from 'hooks/useCopaAlbum';

const CopaAlbumContext = createContext<UseCopaAlbumResult | null>(null);

interface CopaAlbumProviderProps {
  cycleId?: string;
  children: React.ReactNode;
}

export function CopaAlbumProvider({ cycleId, children }: CopaAlbumProviderProps) {
  const value = useCopaAlbum(cycleId);
  return <CopaAlbumContext.Provider value={value}>{children}</CopaAlbumContext.Provider>;
}

export function useCopaAlbumContext(): UseCopaAlbumResult {
  const ctx = useContext(CopaAlbumContext);
  if (!ctx) {
    throw new Error('useCopaAlbumContext deve ser usado dentro de <CopaAlbumProvider>.');
  }
  return ctx;
}
